import { c as o } from "./highrise1048.mjs";
import { queryElement as s } from "./highrise1049.mjs";
function m(e = {}) {
  const r = {
    c: (...t) => o(r, ...t),
    use: (t, ...n) => t.install(r, ...n),
    find: s,
    context: {},
    config: e
  };
  return r;
}
export {
  m as CssRender
};
